module.exports = __webpack_public_path__ + "img/ico_ig.668661f4.svg";